import {Component, Input, OnInit} from '@angular/core';
import {ApprovalsService} from '../approvals.service';
import {SmartModalService} from '../../../../core/services/smart-modal.service';
import {Subscription} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'itpx-create-approval-group',
    templateUrl: './create-approval-group.component.html',
    styleUrls: ['./create-approval-group.component.css']
})
export class CreateApprovalGroupComponent implements OnInit {

    @Input() data : any = null;

    public allSubscriptions: Array<Subscription> = [];
    public fetchedUsers = null;
    public groupDetails = null;

    public formGroup: FormGroup;
    public newGroup: boolean = false;
    public buyerCurrency : any = null;

    constructor(private approvalsService: ApprovalsService, private modalService: SmartModalService, public fb: FormBuilder) {

    }

    ngOnInit(): void {
        this.groupDetails = this.data.groupItem;
        this.newGroup = this.data.newGroup;
        this.buyerCurrency = this.data.buyerCurrency;

        let groupName = this.groupDetails && this.groupDetails.approvalGroup.groupName || null;
        let users = this.groupDetails && this.groupDetails.approvalGroup.users.map(_ => {
            return _.employeeId;
        }) || null;

        this.formGroup = this.fb.group({
            'groupName' : [groupName || null, [Validators.required]],
            'users' : [users || null, [Validators.required]]
        });

        this.searchUsersByName();
    }

    searchUsersByName() {
        this.allSubscriptions.push(
            this.approvalsService.fetchUsersByName().subscribe(_ => {
                this.fetchedUsers = _.map(_ => {
                    return {key: _.employeeId, value: `${_.firstName} ${_.lastName} (${_.email})` };
                });
            })
        );
        this.approvalsService.fetchApprovalGroups().subscribe(_ => console.log(_));
    }

    isFormValid() {
        return this.formGroup &&
            this.formGroup.valid &&
            this.formGroup.get('users') &&
            this.formGroup.get('users').value.length > 0;
    }

    saveApprovalGroup() {
        let payload: any = {
            groupName: this.formGroup.get('groupName').value,
            groupCode: this.formGroup.get('groupName').value,
            users: this.formGroup.get('users').value.map(_ => { return {employeeId: _}})
        };
        if (!this.newGroup) {
            payload.id = this.groupDetails.approvalGroup.id;

            delete payload['groupCode'];

            this.allSubscriptions.push(
                this.approvalsService.editApprovalGroup(payload).subscribe(_ => {
                    this.modalService.sendResult('Approval group updated');
                })
            );
        }
        else {
            this.allSubscriptions.push(
                this.approvalsService.saveApprovalGroup(payload).subscribe(_ => {
                    this.modalService.sendResult('Approval group created');
                })
            );
        }

    }

    editApprovedRule(rule) {

    }

    deleteApprovalRule(rule) {

    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/approvals/create-approval-group/create-approval-group.component.ts